import { React, useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../../contexts/authContext';
import { Link, useParams, useNavigate } from 'react-router-dom';

import { useDisclosure } from '@mantine/hooks';
import { Modal, Group, Button, Loader } from '@mantine/core';
import { format, parseISO } from 'date-fns';

import SyndicRectangleButtonSnd from '../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonSecond';
import OfferCard from '../../Constants/OfferCard';
import DeleteButton from '../../../composents/Buttons/All/DeleteButton/DeleteButton';
import Box from '../../../composents/Boxes/Standard/Box';
import GoBackClosePageOverPictureButton from '../../../composents/Buttons/All/GoBackClosePageOverPictureButton/GoBackClosePageOverPictureButton';
import AppDesktopLogo from '../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';



const PublishedOffer = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [opened, { close, open }] = useDisclosure(false);
    const [deleteError, setDeleteError] = useState(false);
    const [offer, setOffer] = useState(null);
    const [offerAuthorId, setOfferAuthorId] = useState(null);
    const [userId, setUserId] = useState(null);
    let { id } = useParams()

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getSingleOffer();
        getUser();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getSingleOffer = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/offer/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const offer = await response.json();
            setOffer(offer);
            setOfferAuthorId(offer.author._id)
            
        } catch (error) {
        }
    }

    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
            // const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/s/getUser', {

                method: "GET",    
                headers: {
                    Authorization: `Bearer ${token}`
                    }
        });
            const data = await response.json()
            setUserId(data._id)
        }   catch (error) {
            return null;
        }
    }

    const openPDF = (event) => {
        let win = window.open()
        win.document.write('<iframe src="' + event.currentTarget.id  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    };

    const HandleOpenDeleteModal = () => {
    open()
    }

    const HandleDeleteOffer = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/delete/${id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ id }),
            });
            if (!response.ok) {
                setDeleteError(true);
                return;
            }
            navigate('/app/offers/list')
        } catch (error) {
            setDeleteError(true);
        }
    }

    const LOCATION_MATERIEL = [
        'bureaux_equipements',
        'salles_reunion',
        'ateliers',
        'entrepots',
        'espaces_stockage',
        'laboratoires',
        'parking_bornes',
        'machines_industrielles',
        'equipements_production',
        'machines_outils',
        'chambre_froide',
        'lignes_production',
        'equipements_agricoles',
        'equipements_btp',
        'imprimantes_3d',
        'equipements_nettoyage',
        'ordinateurs_ecrans',
        'telephones',
        'materiel_informatique_divers',
        'bureaux_chaises_armoires',
        'cloisons_cabines',
        'rayonnages_etageres',
        'comptoirs_stands',
        'mobilier_stockage',
        'vehicules_utilitaires',
        'camions_remorques',
        'chariots_elevateurs',
        'transpalettes',
        'conteneurs',
        'palettes',
        'caisses_bacs',
        'outillage_divers',
        'instruments_mesure',
        'materiel_securite',
        'materiel_nettoyage',
        'metaux_bois_plastiques',
        'textiles',
        'verre',
        'papier_carton',
        'produits_semi_finis',
        'surstocks_industriels',
        'chutes_production',
        'stands_exposition',
        'showrooms',
        'kakemonos_plv',
        'structures_modulaires',
        'equipements_son_lumiere',
        'tentes_podiums'
    ];
    
    const isLocationMat = offer ? LOCATION_MATERIEL.includes(offer.ressource) : false;
    
    const VENTE_MATERIEL = [
        'bureaux_equipements',
        'salles_reunion',
        'ateliers',
        'entrepots',
        'espaces_stockage',
        'laboratoires',
        'parking_bornes',
        'machines_industrielles',
        'equipements_production',
        'machines_outils',
        'chambre_froide',
        'lignes_production',
        'equipements_agricoles',
        'equipements_btp',
        'imprimantes_3d',
        'equipements_nettoyage',
        'ordinateurs_ecrans',
        'telephones',
        'materiel_informatique_divers',
        'bureaux_chaises_armoires',
        'cloisons_cabines',
        'rayonnages_etageres',
        'comptoirs_stands',
        'mobilier_stockage',
        'vehicules_utilitaires',
        'camions_remorques',
        'chariots_elevateurs',
        'transpalettes',
        'conteneurs',
        'palettes',
        'caisses_bacs',
        'outillage_divers',
        'instruments_mesure',
        'materiel_securite',
        'materiel_nettoyage',
        'metaux_bois_plastiques',
        'textiles',
        'verre',
        'papier_carton',
        'produits_semi_finis',
        'surstocks_industriels',
        'chutes_production',
        'stands_exposition',
        'showrooms',
        'kakemonos_plv',
        'structures_modulaires',
        'equipements_son_lumiere',
        'tentes_podiums'
    ];
    const isSaleMat = offer ? VENTE_MATERIEL.includes(offer.ressource) : false;
    
    const DON = [
        'bureaux_equipements',
        'salles_reunion',
        'ateliers',
        'entrepots',
        'espaces_stockage',
        'laboratoires',
        'parking_bornes',
        'machines_industrielles',
        'equipements_production',
        'machines_outils',
        'chambre_froide',
        'lignes_production',
        'equipements_agricoles',
        'equipements_btp',
        'imprimantes_3d',
        'equipements_nettoyage',
        'ordinateurs_ecrans',
        'telephones',
        'materiel_informatique_divers',
        'bureaux_chaises_armoires',
        'cloisons_cabines',
        'rayonnages_etageres',
        'comptoirs_stands',
        'mobilier_stockage',
        'vehicules_utilitaires',
        'camions_remorques',
        'chariots_elevateurs',
        'transpalettes',
        'conteneurs',
        'palettes',
        'caisses_bacs',
        'outillage_divers',
        'instruments_mesure',
        'materiel_securite',
        'materiel_nettoyage',
        'metaux_bois_plastiques',
        'textiles',
        'verre',
        'papier_carton',
        'produits_semi_finis',
        'surstocks_industriels',
        'chutes_production',
        'stands_exposition',
        'showrooms',
        'kakemonos_plv',
        'structures_modulaires',
        'equipements_son_lumiere',
        'tentes_podiums'
    ];
    const isDon = offer ? DON.includes(offer.ressource) : false;

    const PRESTATION_SERVICE = [
        'journee_expertise',
        'assistance_technique',
        'conseil_strategique',
        'audit',
        'coaching_mentorat',
        'formation'
    ];
    const isPrestaSce = offer ? PRESTATION_SERVICE.includes(offer.ressource) : false;

    const RESSOURCE_IMMATERIELLE = [
        'licences_logiciels',
        'acces_saas',
        'developpements_reutilisables',
        'templates_scripts',
        'api'
    ];
    const isRceImmat = offer ? RESSOURCE_IMMATERIELLE.includes(offer.ressource) : false;

    return (
        offer ?
            <>
                {isMobile ? (
                    <>
                        <OfferCard />
                        <GoBackClosePageOverPictureButton />
                        
                        {offerAuthorId && userId && offerAuthorId === userId && offer.status === "open" &&  (
                            <div className="width90pCenter mrgT30">
                                <Link to={`/app/offers/offer-edit/${id}`}>
                                <SyndicRectangleButtonSnd>
                                    Modifier mon offre
                                </SyndicRectangleButtonSnd>
                                </Link>

                                <div className="mrgB20"></div>

                                <DeleteButton onClick={HandleOpenDeleteModal}>
                                Supprimer l'offre
                                </DeleteButton>

                                {open && (
                                <Modal
                                    centered
                                    withCloseButton={false}
                                    opened={opened}
                                    onClose={close}
                                    size="auto"
                                >
                                    <Group noWrap mt="md" className="horizontal jCenter mrgT5">
                                    <p className="noMrgTB txt15">Supprimer l'offre ?</p>
                                    </Group>

                                    {deleteError && (
                                        <p className="txtCenter rT txt13 mrgT10 noMrgB">
                                            Une erreur est survenue. Veuillez réessayer.
                                        </p>
                                    )}

                                    <Group mt="xl" className="txtCenter horizontal jCenter mrgT20">
                                    <Button variant="outline" color="dark" onClick={close}>
                                        Annuler
                                    </Button>
                                    <Button variant="filled" color="dark" onClick={HandleDeleteOffer} className="medium">
                                        Supprimer
                                    </Button>
                                    </Group>
                                </Modal>
                                )}

                                <div className="mrgB20"></div>
                            </div>
                        )}

                        {offer.status === "booked" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Nouvelle demande</h1>
                            <p className="txt16 noMrgT mrgB10">Vous avez 72H pour accepter la demande</p>

                            <Box className="width90pCenter">
                            <p className="noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Date de la demande :</span> {format(parseISO(offer.payDate), "dd/MM/yy")}
                            </p>

                            {offer.contrat === "Location" && offer.bookedRangeDates?.length > 0 && (
                                <p className="vertical noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Dates de location demandées :</span>
                                <span className="mrgL10">
                                    {offer.bookedRangeDates.map((r, i) => (
                                        <div key={i}>
                                        • du {new Date(r.start).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })} au {new Date(r.end).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })}
                                        </div>
                                    ))}
                                </span>
                                </p>
                            )}

                            {offer.contrat === "Location" && offer.volume && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                {offer.price * offer.volume} €
                                </div>
                            )}

                            {offer.contrat === "Vente" && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                {offer.price} €
                                </div>
                            )}

                            {offer.contrat === "Don" && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                Don à 0 €
                                </div>
                            )}
                            </Box>
                        </div>
                        )}

                        {offer.status === "deal" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Prestation en cours</h1>

                            <Box className="width90pCenter">
                            <p className="noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Date de la demande :</span> {format(parseISO(offer.payDate), "dd/MM/yy")}
                            </p>

                            {offer.contrat === "Location" && offer.bookedRangeDates?.length > 0 && (
                                <p className="vertical noMrgB mrgT10 txt16 mrgL10">
                                <div className="horizontal">
                                    <span className="mediumplus">Dates de location demandées :</span>
                                    <span className="mrgL10">
                                    {offer.bookedRangeDates.map((r, i) => (
                                        <div key={i}>
                                        du {new Date(r.start).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })} au {new Date(r.end).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })}
                                        </div>
                                    ))}
                                    </span>
                                </div>
                                </p>
                            )}

                            {offer.contrat === "Location" && offer.volume && (
                                <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price * offer.volume} €</span>
                                    </div>

                                    <div>
                                        {isLocationMat && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de location de biens matériels
                                        </Button>
                                        )}
                                        {isPrestaSce && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de prestation de services / compétences
                                        </Button>
                                        )}
                                        {isRceImmat && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de mise à disposition de ressources immatérielles / licences
                                        </Button>
                                        )}
                                    </div>

                                    <Button>PDF : Confirmation de réservation et blocage de fonds</Button>
                                </div>
                            )}

                            {offer.contrat === "Vente" && (
                                <div className="vertical">
                                <div className="horizontal">
                                    <span className="mediumplus mrgR5">Montant total HT :</span>
                                    <span>{offer.price} €</span>
                                </div>

                                <div>
                                    {isSaleMat && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Vente de biens matériels
                                    </Button>
                                    )}
                                    {isRceImmat && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Vente de ressources immatérielles / licences
                                    </Button>
                                    )}
                                </div>

                                <Button>PDF : Confirmation de réservation et blocage de fonds</Button>
                                </div>
                            )}

                            {offer.contrat === "Don" && (
                                <div className="vertical">
                                <div className="horizontal">
                                    <span className="mediumplus mrgR5">Montant total HT :</span>
                                    <span>Don à 0 €</span>
                                </div>

                                <div>
                                    {isDon && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Don de matériel
                                    </Button>
                                    )}
                                </div>
                                </div>
                            )}
                            </Box>
                        </div>
                        )}

                        {offer.status === "done" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Prestation reçue et validée par votre client</h1>

                            <Box className="width95pCenter">
                                <p className="noMrgB mrgT10 txt16 mrgL10">
                                    <span className="mediumplus">Date de validation :</span> {format(parseISO(offer.confirmationPrestaDate), "dd/MM/yy")}
                                </p>

                                {offer.contrat === "Location" && offer.volume && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price * offer.volume} €</span>
                                    </div>

                                    <div>
                                        {(isLocationMat || isPrestaSce || isRceImmat) && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre reçu de paiement
                                        </Button>
                                        )}

                                    </div>
                                    </div>
                                )}

                                {offer.contrat === "Vente" && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price} €</span>
                                    </div>

                                    <div>
                                        {(isSaleMat || isRceImmat) && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre reçu de paiement
                                        </Button>
                                        )}
                                    </div>
                                    </div>
                                )}

                                {offer.contrat === "Don" && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>Don à 0 €</span>
                                    </div>

                                    <div>
                                        {isDon && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre attestation de don
                                        </Button>
                                        )}
                                    </div>
                                    </div>
                                )}
                                
                                <Button>Archiver : il va la fin</Button>
                            </Box>
                        </div>
                        )}


                        <div className='mrgB75'/>
                    </>
                ) : (
                    <>
                        <AppDesktopLogo/>
                        <OfferCard
                            desktopBackButton={<GoBackClosePageOverPictureButton />}
                            desktopFooterActions={
                                offerAuthorId && userId && offerAuthorId === userId && offer.status === "open" && (
                                    <div className="horizontal" style={{ gap: 12 }}>
                                        <Link to={`/app/offers/offer-edit/${id}`}>
                                        <Button
                                            color="dark"
                                            radius="xl"
                                            size="lg"
                                            styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                        >
                                            Modifier mon offre
                                        </Button>
                                        </Link>

                                        <Button
                                            variant="outline"
                                            color="red"
                                            radius="xl"
                                            size="lg"
                                            styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                            onClick={HandleOpenDeleteModal}
                                        >
                                            Supprimer l'offre
                                        </Button>

                                        {open && (
                                        <Modal
                                            centered
                                            withCloseButton={false}
                                            opened={opened}
                                            onClose={close}
                                            size="auto"
                                        >
                                            <Group noWrap mt="md" className="horizontal jCenter mrgT5">
                                            <p className="noMrgTB txt15">Supprimer l'offre ?</p>
                                            </Group>

                                            {deleteError && (
                                                <p className="txtCenter rT txt13 mrgT10 noMrgB">
                                                    Une erreur est survenue. Veuillez réessayer.
                                                </p>
                                            )}

                                            <Group mt="xl" className="txtCenter horizontal jCenter mrgT20">
                                            <Button variant="outline" color="dark" onClick={close}>
                                                Annuler
                                            </Button>
                                            <Button variant="filled" color="dark" onClick={HandleDeleteOffer} className="medium">
                                                Supprimer
                                            </Button>
                                            </Group>
                                        </Modal>
                                        )}
                                    </div>
                                )
                            }
                        />

                        {offer.status === "booked" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Nouvelle demande</h1>
                            <p className="txt16 noMrgT mrgB10">Vous avez 72H pour accepter la demande</p>

                            <Box className="width90pCenter">
                            <p className="noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Date de la demande :</span> {format(parseISO(offer.payDate), "dd/MM/yy")}
                            </p>

                            {offer.contrat === "Location" && offer.bookedRangeDates?.length > 0 && (
                                <p className="vertical noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Dates de location demandées :</span>
                                <span className="mrgL10">
                                    {offer.bookedRangeDates.map((r, i) => (
                                        <div key={i}>
                                        • du {new Date(r.start).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })} au {new Date(r.end).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })}
                                        </div>
                                    ))}
                                </span>
                                </p>
                            )}

                            {offer.contrat === "Location" && offer.volume && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                {offer.price * offer.volume} €
                                </div>
                            )}

                            {offer.contrat === "Vente" && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                {offer.price} €
                                </div>
                            )}

                            {offer.contrat === "Don" && (
                                <div>
                                <span className="mediumplus mrgR5">Montant total HT :</span>
                                Don à 0 €
                                </div>
                            )}
                            </Box>
                        </div>
                        )}

                        {offer.status === "deal" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Prestation en cours</h1>

                            <Box className="width90pCenter">
                            <p className="noMrgB mrgT10 txt16 mrgL10">
                                <span className="mediumplus">Date de la demande :</span> {format(parseISO(offer.payDate), "dd/MM/yy")}
                            </p>

                            {offer.contrat === "Location" && offer.bookedRangeDates?.length > 0 && (
                                <p className="vertical noMrgB mrgT10 txt16 mrgL10">
                                <div className="horizontal">
                                    <span className="mediumplus">Dates de location demandées :</span>
                                    <span className="mrgL10">
                                    {offer.bookedRangeDates.map((r, i) => (
                                        <div key={i}>
                                        du {new Date(r.start).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })} au {new Date(r.end).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })}
                                        </div>
                                    ))}
                                    </span>
                                </div>
                                </p>
                            )}

                            {offer.contrat === "Location" && offer.volume && (
                                <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price * offer.volume} €</span>
                                    </div>

                                    <div>
                                        {isLocationMat && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de location de biens matériels
                                        </Button>
                                        )}
                                        {isPrestaSce && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de prestation de services / compétences
                                        </Button>
                                        )}
                                        {isRceImmat && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Modèle Contrat de mise à disposition de ressources immatérielles / licences
                                        </Button>
                                        )}
                                    </div>

                                    <Button>PDF : Confirmation de réservation et blocage de fonds</Button>
                                </div>
                            )}

                            {offer.contrat === "Vente" && (
                                <div className="vertical">
                                <div className="horizontal">
                                    <span className="mediumplus mrgR5">Montant total HT :</span>
                                    <span>{offer.price} €</span>
                                </div>

                                <div>
                                    {isSaleMat && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Vente de biens matériels
                                    </Button>
                                    )}
                                    {isRceImmat && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Vente de ressources immatérielles / licences
                                    </Button>
                                    )}
                                </div>

                                <Button>PDF : Confirmation de réservation et blocage de fonds</Button>
                                </div>
                            )}

                            {offer.contrat === "Don" && (
                                <div className="vertical">
                                <div className="horizontal">
                                    <span className="mediumplus mrgR5">Montant total HT :</span>
                                    <span>Don à 0 €</span>
                                </div>

                                <div>
                                    {isDon && (
                                    <Button
                                        id={offer.acceptedQuotation.downloadLink}
                                        onClick={openPDF}
                                        variant="filled"
                                        radius="md"
                                        color="dark"
                                        size="compact-md"
                                        className="mrgLauto mrgR10"
                                    >
                                        Modèle Contrat de Don de matériel
                                    </Button>
                                    )}
                                </div>
                                </div>
                            )}
                            </Box>
                        </div>
                        )}

                        {offer.status === "done" && (
                        <div className="width90pCenter">
                            <h1 className="txt20 cap mrgT20 mrgB10">Prestation reçue et validée par votre client</h1>

                            <Box className="width95pCenter">
                                <p className="noMrgB mrgT10 txt16 mrgL10">
                                    <span className="mediumplus">Date de validation :</span> {format(parseISO(offer.confirmationPrestaDate), "dd/MM/yy")}
                                </p>

                                {offer.contrat === "Location" && offer.volume && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price * offer.volume} €</span>
                                    </div>

                                    <div>
                                        {(isLocationMat || isPrestaSce || isRceImmat) && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre reçu de paiement
                                        </Button>
                                        )}

                                    </div>
                                    </div>
                                )}

                                {offer.contrat === "Vente" && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>{offer.price} €</span>
                                    </div>

                                    <div>
                                        {(isSaleMat || isRceImmat) && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre reçu de paiement
                                        </Button>
                                        )}
                                    </div>
                                    </div>
                                )}

                                {offer.contrat === "Don" && (
                                    <div className="vertical">
                                    <div className="horizontal">
                                        <span className="mediumplus mrgR5">Montant total HT :</span>
                                        <span>Don à 0 €</span>
                                    </div>

                                    <div>
                                        {isDon && (
                                        <Button
                                            id={offer.acceptedQuotation.downloadLink}
                                            onClick={openPDF}
                                            variant="filled"
                                            radius="md"
                                            color="dark"
                                            size="compact-md"
                                            className="mrgLauto mrgR10"
                                        >
                                            Votre attestation de don
                                        </Button>
                                        )}
                                    </div>
                                    </div>
                                )}
                                
                                <Button>Archiver : il va la fin</Button>
                            </Box>
                        </div>
                        )}


                        <div className='mrgB75'/>
                    </>
                )}
            </>
        : 
        <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )

}

export default PublishedOffer;